import { newProgress, type PlayerProgress } from '@nine/shared';

/**
 * The opening's ink scenes (data/scenes.ts `opening-legend`, `opening-pact`): client0 drops the player
 * straight into play at the hub (user, 2026-10-10: "เล่นได้แบบในรูป"), so they count as seen. The rest of
 * the story (scenes tied to the START zone) still plays where it belongs. Replay from the legend window.
 */
const OPENING = ['opening-legend', 'opening-pact'] as const;

/** Marks the opening as seen on a save (new or old), so the world opens on play, not on the ink cutscene. */
export function skipOpening(p: PlayerProgress): PlayerProgress {
  for (const id of OPENING) if (!p.scenes.includes(id)) p.scenes.push(id);
  return p;
}

/** client0 starts every new character at the plains hub (ลานศิลาเก้ากระบี่), not at shared's START zone. */
export function newPlayer(): PlayerProgress {
  const p = newProgress();
  p.location = 'plains';
  p.arriveFrom = null;
  p.indoors = null;
  return skipOpening(p);
}
